export default __webpack_public_path__ + "static/media/Trusty.9a968d87.jpg";